import React from 'react';
import { Animated, StyleProp, StyleSheet, ViewStyle } from 'react-native';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const styles = StyleSheet.create({
    root: {
        height: 1,
        backgroundColor: ds.colorValue.border.strong,
    },
    vertical: {
        width: 1,
        height: '100%',
    },
});

const variantStyles = StyleSheet.create({
    error: {
        backgroundColor: ds.colorValue.background.danger.strong,
    },
    neutral: {
        backgroundColor: designSystem.colors.neutral300,
    },
});

// restrict setting a different bg color for the separator
// if needed, we can add a new variant
type NoBackgroundColor = { backgroundColor?: never };
export type LineSeparatorStyle = Omit<ViewStyle, 'backgroundColor'> & NoBackgroundColor;

type Props = {
    vertical?: boolean;
    style?: StyleProp<LineSeparatorStyle>;
    variant?: 'error' | 'neutral';
    flex?: number;
    testID?: string;
};

export const LineSeparator = ({ vertical = false, style = {}, variant, ...rest }: Props) => {
    return (
        <Animated.View
            style={[styles.root, vertical && styles.vertical, style, variant && variantStyles[variant]]}
            {...rest}
        />
    );
};
